



























































































































































































































































































































































































import Axios from 'axios';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class Nav extends Vue {
  @Prop(String)
  public pageTitle!: string;

  data() {
    return {
      drawer: null,    
      title: "",
      group:'',
      activate: true,
      expand: false,
        
        headers: [{
                text: "Jobs",
                name: "all job"
            },
            {
                text: "Talent",
                name: "search"
            },
            {
                text: "Applied Job",
                name: "applied_job"
            }
        ],
    };
  }

  get adminUser() {
    // let admin = localStorage.getItem("admin_name");
    // let name = admin.substring(0, admin.lastIndexOf("@"));
    // return localStorage.getItem("admin_name") !== null? name : "";
    let account_name = localStorage.getItem("account_name");
    return localStorage.getItem("account_name") !== null? account_name : "";
  }

  get adminProfile(){
        let profile_image_url = localStorage.getItem("profile_image_url");
        return localStorage.getItem("profile_image_url") !== null? profile_image_url : "";
  }


  async logOut() {
    console.log("dfgdfg");
    const jwt = localStorage.getItem("jwt");
    const is_admin = localStorage.getItem("is_admin");
    const admin_name = localStorage.getItem("admin_name");
    const userId = localStorage.getItem("userId");
    const auth = {
      headers: {authorization: jwt} 
    }  

    let resp = await Axios.post('https://api.crackingitjobs.com/auth/logout', {user_id: userId},auth)

    console.log("dfgdfg",resp);
    if (resp.status === 200 && resp.data.message === "Logout successful") {
      if (jwt) {
        localStorage.removeItem("jwt");
      }
      if (is_admin) {
        localStorage.removeItem("is_admin");
      }
      if (admin_name) {
        localStorage.removeItem("admin_name");
      }
      window.location.href ='https://crackingitjobs.com/#/';
    }
  }
}
